import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {currencyFormat} from "../../../utils/masks";
import {getReport} from "../../../services/Trading";
import {useTranslation} from "react-i18next";
import {FaTrophy, FaCoins} from "react-icons/fa";
import {
    InsightStack,
    InsightRow,
    InsightIconBox,
    InsightText,
    InsightTitle,
    InsightDesc,
    InsightValue,
    InsightBadge,
    getAccent,
} from "../TradingInsightCard/styles";

export default function CardTotalGain({filter}) {
    const {coinType, amount} = useSelector((state) => state.BankReducer);
    const [percentQtdeWin, setPercentQtdeWin] = useState(null);
    const [, setPercentTotalValueWin] = useState(null);

    const [totalValueWin, setTotalValueWin] = useState(null);
    const [totalValueLoss, setTotalValueLoss] = useState(null);
    const [qtdeWin, setQtdeWin] = useState(null);
    const [qtdeLoss, setQtdeLoss] = useState(null);
    const [qtdeDraw, setQtdeDraw] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        const value = (qtdeLoss + qtdeWin + qtdeDraw) ? qtdeWin * 100 / (qtdeLoss + qtdeWin + qtdeDraw) : 0;
        setPercentQtdeWin(value.toFixed(2));
    }, [qtdeWin, qtdeLoss, qtdeDraw]);

    useEffect(() => {
        const value = amount && totalValueWin ? totalValueWin * 100 / ((amount + (totalValueLoss*-1)) - totalValueWin): 0;
        setPercentTotalValueWin(value.toFixed(2));
    }, [totalValueLoss, totalValueWin, amount]);

    useEffect(() => {

        getReport({
            startDate: filter[0].startDate,
            endDate: filter[0].endDate,
            orderBy: 'profitObtained',
            order: 'DESC'
        }).then((data) => {
            if (!data || data === '' || !data.data) {
                return;
            }

            setTotalValueWin(parseFloat(data.data.win.totalValue ? data.data.win.totalValue : 0));
            setTotalValueLoss(parseFloat(data.data.loss.totalValue ? data.data.loss.totalValue : 0));

            setQtdeWin(data.data.win.qtde);
            setQtdeLoss(data.data.loss.qtde);
            setQtdeDraw(data.data.draw.qtde);
        });
    }, [filter]);

    const a = getAccent('win');

    return (
        <InsightStack>
            <InsightRow $variant="win">
                <InsightIconBox $variant="win">
                    <FaTrophy aria-hidden/>
                </InsightIconBox>
                <InsightText>
                    <InsightTitle>{t('traging_report_card_win_victories')}</InsightTitle>
                    <InsightDesc>{t('trading_report_desc_win_count')}</InsightDesc>
                </InsightText>
                <InsightValue $color={a.value} style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6}}>
                    <span>{qtdeWin != null ? qtdeWin : '—'}</span>
                    <InsightBadge $variant="win" style={{marginLeft: 0}}>{percentQtdeWin != null ? `${percentQtdeWin}%` : '—'}</InsightBadge>
                </InsightValue>
            </InsightRow>
            <InsightRow $variant="win">
                <InsightIconBox $variant="win">
                    <FaCoins aria-hidden/>
                </InsightIconBox>
                <InsightText>
                    <InsightTitle>{t('traging_report_card_win_value_gain')}</InsightTitle>
                    <InsightDesc>{t('trading_report_desc_win_value')}</InsightDesc>
                </InsightText>
                <InsightValue $color={a.value}>
                    {coinType} {totalValueWin != null ? currencyFormat(parseFloat(totalValueWin)) : '—'}
                </InsightValue>
            </InsightRow>
        </InsightStack>
    );
}
